/**
 * 달력 격자를 만드는 날짜 계산. v1 `lib/monthlyMeetings.ts` 에서 날짜 부분만 떼어 왔다.
 *
 * 모든 함수가 시각을 자정으로 맞춘다 — 맞추지 않으면 같은 날짜인데도 시:분이 달라
 * 비교가 어긋나고, 달력에서 하루가 통째로 빠지거나 겹친다.
 */

export function addDays(base: Date, days: number): Date {
  const date = new Date(base);
  date.setDate(date.getDate() + days);
  date.setHours(0, 0, 0, 0);
  return date;
}

export function addMonths(base: Date, months: number): Date {
  const date = new Date(base);
  date.setMonth(date.getMonth() + months);
  date.setHours(0, 0, 0, 0);
  return date;
}

export function startOfMonth(base: Date): Date {
  return new Date(base.getFullYear(), base.getMonth(), 1);
}

export function endOfMonth(base: Date): Date {
  return new Date(base.getFullYear(), base.getMonth() + 1, 0);
}

/** `YYYY-MM-DD` 를 로컬 자정 Date 로. `new Date('2026-07-01')` 은 UTC 로 읽혀 하루가 밀린다. */
export function parseDate(value: string): Date {
  const date = new Date(`${value}T00:00:00`);
  date.setHours(0, 0, 0, 0);
  return date;
}

/** 그 달을 담되 일요일에서 시작해 토요일에 끝나는 구간. 달력이 항상 온전한 주로 채워진다. */
export function getCalendarRange(base: Date): { start: Date; end: Date } {
  const start = startOfMonth(base);
  start.setDate(start.getDate() - start.getDay());
  start.setHours(0, 0, 0, 0);

  const end = endOfMonth(base);
  end.setDate(end.getDate() + (6 - end.getDay()));
  end.setHours(0, 0, 0, 0);

  return { start, end };
}

/** 구간에 든 모든 날짜. */
export function eachDayOfRange(start: Date, end: Date): Date[] {
  const days: Date[] = [];
  let cursor = new Date(start);

  while (cursor <= end) {
    days.push(new Date(cursor));
    cursor = addDays(cursor, 1);
  }

  return days;
}

export function getMonthLabel(base: Date): string {
  return `${base.getFullYear()}년 ${base.getMonth() + 1}월`;
}

/** `HH:MM`. 저장 형식이 `9:5` 처럼 들쭉날쭉해도 화면에서는 자리를 맞춘다. */
export function formatEventTime(value: string | null): string | null {
  if (!value) return null;

  const [hour, minute] = value.split(':');
  if (!hour || !minute) return value;
  return `${hour.padStart(2, '0')}:${minute.padStart(2, '0')}`;
}
